export const rowsFieldSirInterventionBySuppliers = [
  { name: "No Intervention", field: "noInterventionCount", color: "#5D64DE" },
  { name: "SIR Amended", field: "sirAmendedCount", color: "#E8618C" },
  { name: "ESP Amended", field: "espAmendedCount", color: "#12BA98" },
  { name: "ESP & SIR Amended", field: "sirEspAmendedCount", color: "#1890FF" },
  { name: "Not matched", field: "notMatchedCount", color: "#FFAE4C" },
];

export const rowsFieldTeamPerformanceByApOwner = [
  { name: "Auto Match", field: "autoMatch", color: "#5D64DE" },
  { name: "Manually Match", field: "manuallyMatch", color: "#E8618C" },
  { name: "In Progress", field: "inProgress", color: "#12BA98" },
  { name: "Not Started", field: "notStarted", color: "#1890FF" },
  { name: "Rejected", field: "rejected", color: "#FFAE4C" },
];

export const rowsFieldTeamActions = [
  { name: "Team", field: "team", color: "#5D64DE" },
];

export const COLORS = [
  "#848af3ff",
  "#E8618C",
  "#12BA98",
  "#EF4444",
  "#07DBFA",
  "#FFAE4C",
  "#2479a3ff",
  "#A855F7",
  "#1bbf57ff",
  "#f6d036ff",
];
